import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { selectPowerBIIsLoading, selectReports } from '@store/selectors/power-bi/power-bi.selectors';
import { Report } from '@models/powerBIEmbed.model';
import { CPG_REPORT_CATEGORY } from '@constants/power-bi-report-categories';

@Component({
  selector: 'app-power-bi-cpg-landing',
  imports: [AsyncPipe, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './power-bi-cpg-landing.component.html',
  styleUrl: './power-bi-cpg-landing.component.css',
})
export class PowerBiCpgLandingComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  readonly isLoading$ = this.store.select(selectPowerBIIsLoading);

  readonly cpgReports$ = this.store.select(selectReports).pipe(
    map((reports: Report[]) => reports.filter(report => report.category === CPG_REPORT_CATEGORY))
  );

  openReport(report: Report): void {
    this.router.navigate(['/bi', report.reportId]);
  }

  goBackToHub(): void {
    this.router.navigate(['/bi']);
  }
}
